// Its own file, away from token.ts: that one uses node crypto and must never reach the
// browser bundle.

/** A fresh token, fetched right before the form posts. Null means posting without one. */
export async function fetchContactToken(): Promise<string | null> {
  try {
    const res = await fetch("/api/contact/token", { cache: "no-store" });
    if (!res.ok) return null;
    const data = (await res.json()) as { token?: unknown };
    return typeof data.token === "string" ? data.token : null;
  } catch {
    return null;
  }
}
